/** Plain DOM fallback: it must work even when the root chunk cannot load. */
import { languageCookie, localeCookieOptionsFromEnv, resolveLanguage } from '@fusapp-work/shell'
import { IS_COSMOS } from './config/instance'
import tr from './locales/tr.json'
import en from './locales/en.json'

export function renderBootFailure(root: HTMLElement | null, error: unknown): void {
  console.error('Auth could not start', error)
  let cookieLanguage: unknown
  if (IS_COSMOS) {
    try {
      cookieLanguage = languageCookie(localeCookieOptionsFromEnv(import.meta.env)).read().language
    } catch (configurationError) {
      console.warn('[surface-locale] Invalid cookie configuration; using browser language.', configurationError)
    }
  }
  const language = IS_COSMOS
    ? resolveLanguage({ cookie: cookieLanguage, navigatorLanguages: navigator.languages ?? [navigator.language], fallback: 'tr' })
    : 'tr'
  const messages = { tr, en }[language].auth.bootFailure
  document.documentElement.lang = language
  const panel = document.createElement('main')
  panel.lang = language
  panel.setAttribute('role', 'alert')
  panel.style.cssText = 'max-width: 520px; margin: 15vh auto 0; padding: 24px; color: #111827; background: #fff; font-family: system-ui, sans-serif; line-height: 1.5;'
  const title = document.createElement('h1')
  title.textContent = messages.title
  title.style.fontSize = '20px'
  const body = document.createElement('p')
  body.textContent = messages.body
  const reload = document.createElement('button')
  reload.type = 'button'
  reload.textContent = messages.reload
  reload.style.cssText = 'min-height: 36px; padding: 8px 12px; color: #111827; background: #fff; border: 1px solid #4b5563; cursor: pointer;'
  reload.addEventListener('click', () => window.location.reload())
  panel.append(title, body, reload)
  ;(root ?? document.body).replaceChildren(panel)
}
